<template>
  <v-container fluid class="" v-if="getPermission('setting:view')">
    <v-layout>
      <v-flex>
        <h3
          class="font-weight-700 mb-0 font-size-24 custom-headline color-custom-blue"
        >
          Zone Management
        </h3>
        <p class="mb-0">Manage service zones and postal code assignments</p>
      </v-flex>
      <v-flex class="text-right">
        <v-btn
          depressed
          small
          class="mx-4 white--text"
          v-on:click="zoneDialogOpen"
          color="cyan"
        >
          <span class="font-size-16 font-weight-600">
            <v-icon left small>mdi-plus</v-icon> Create New Zone</span
          >
        </v-btn>
        <v-btn
          depressed
          class="custom-grey-border custom-bold-button"
          v-on:click="goBack"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </v-flex>
    </v-layout>

    <perfect-scrollbar
      :options="{ suppressScrollX: true }"
      class="scroll custom-box-top-inner-shado"
      style="height: calc(100vh - 150px); position: relative"
    >
      <v-row>
        <v-col cols="12" sm="6" md="4" v-for="(zone, i) in zoneList" :key="i">
          <v-card outlined class="pa-5 rounded-lg">
            <!-- Header -->
            <div class="d-flex justify-space-between align-center mb-2">
              <span class="text-h6 font-weight-600">{{ zone.name }}</span>
              <div class="d-flex align-center">
                <v-switch
                  color="green"
                  dense
                  hide-details
                  v-model="zone.is_active"
                  @change="toggleStatus(zone)"
                ></v-switch>

                  <!-- <v-chip
                    small
                    :color="zone.isStatus ? 'green lighten-5' : 'grey lighten-3'"
                    :text-color="
                      zone.isStatus ? 'green darken-2' : 'grey darken-2'
                    "
                    class="font-weight-600 px-3"
                    style="height: 24px"
                  >
                    {{ zone.status }}
                  </v-chip> -->
              </div>
            </div>

            <!-- Details -->
            <div class="mb-2">
              <p class="mb-1">
                <v-icon small color="green darken-2" class="mr-2"
                  >mdi-map-marker</v-icon
                >
                <span class="green--text fw-600">{{
                  zone.activepostalCodes
                }}</span>
                active postal codes
              </p>
              <p class="mb-1">
                <v-icon small color="red darken-2" class="mr-2"
                  >mdi-map-marker</v-icon
                >
                <span class="red--text fw-600"
                  >{{ zone.inactivepostalCodes }}
                </span>
                inactive postal codes
              </p>

               <p class="mb-1">
                <v-icon small color="grey darken-2" class="mr-2"
                  >mdi-account-multiple</v-icon
                >
                {{ zone.drivers }} technicians assigned
              </p>
              
              <p class="mb-1">
                <v-icon small color="grey darken-2" class="mr-2"
                  >mdi-calendar</v-icon
                >
                Created: {{ zone.added_at }}
              </p>
            </div>

            <!-- Actions -->
            <div class="d-flex justify-space-between mt-4">
             
              <v-btn
                depressed
                small
                class="custom-bold-button flex-grow-1 text-center mr-2"
                :to="{ name: 'admin.zone.view', params: { id: zone.id } }"
              >
                <span class="font-size-16 font-weight-600">
                  <v-icon left small>mdi-eye</v-icon> View
                </span>
              </v-btn>
              <v-btn
                v-on:click="updatezonesType(zone)"
                depressed
                small
                color="blue darken-2"
                class="white--text flex-grow-1 mr-2"
              >
                <span class="font-size-16 font-weight-600">
                  <v-icon left small>mdi-pencil</v-icon> Edit
                </span>
              </v-btn>
              <v-btn
                v-on:click="deleteZones(zone)"
                depressed
                small
                color="red lighten-5"
                class="flex-grow-0"
              >
                <v-icon color="red darken-2">mdi-delete</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </perfect-scrollbar>
    <!-- Create New Zone -->
    <Dialog :commonDialog="addZoneDialog" :dialog-width="600">
      <template v-slot:title>
        <template v-if="zonePayload?.id > 0">Edit</template
        ><template v-else>Create New</template> Zone
      </template>
      <template v-slot:body>
        <v-container fluid>
          <v-form
            ref="ticketCollecttionFormSkills"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="updateJobSettingZone"
          >
            <v-row>
              <v-col md="12">
                <label class="my-auto fw-500 required mb-1">Zone Name</label>
                <TextField
                  id="quotation-title"
                  dense
                  filled
                  placeholder="Enter zone Name"
                  solo
                  flat
                  counter="50"
                  v-model.trim="zonePayload.name"
                  color="cyan"
                  :maxlength="250"
                  :rules="[
                    validateRules.required(zonePayload.name, 'Zone Name'),
                  ]"
                />
              </v-col>
              <v-col md="12">
                <label class="my-auto fw-500 required mb-1">Country</label>
                <v-autocomplete
                  hide-details
                  v-model.trim="zonePayload.country"
                  :items="countryList"
                  dense
                  flat
                  filled
                  item-color="cyan"
                  color="cyan"
                  solo
                  item-value="value"
                  item-text="text"
                  placeholder="Select Country"
                  :rules="[
                    validateRules.required(zonePayload.country, 'Country'),
                  ]"
                />
              </v-col>
              <v-col md="12">
                <label class="my-auto fw-500 required mb-1">Status</label>
                
                <v-autocomplete
                  hide-details
                  v-model.trim="zonePayload.status"
                  :items="statusList"
                  dense
                  flat
                  filled
                  item-color="cyan"
                  color="cyan"
                  solo
                  item-value="value"
                  item-text="text"
                  placeholder="Select Status"
                  :rules="[
                    validateRules.required(zonePayload.status, 'Status'),
                  ]"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :loading="pageLoading"
          :disabled="pageLoading || !formValid"
          class="mx-2 custom-grey-border custom-bold-button"
          color="cyan white--text"
          v-on:click="updateJobSettingData(is_exist)"
        >
          Save
        </v-btn>
        <v-btn
          depressed
          :disabled="pageLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="addZoneDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
    <Dialog :common-dialog="confirm_dialog" :dialog-width="850">
      <template v-slot:title> Confirmation </template>
      <template v-slot:body>
        <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
          <v-container class="px-10" fluid>
            <h3 class="font-weight-500 text-center">
              Zone already exists in another transaction. Any updates will be
              reflected in a new transaction.
            </h3>
          </v-container>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="confirm_loading"
          v-on:click="confirm_dialog = false"
          class="mx-2 custom-grey-border custom-bold-button"
        >
          No! Close
        </v-btn>
        <v-btn
          v-on:click="updateJobSettingZone()"
          :disabled="!formValid || confirm_loading"
          :loading="confirm_loading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
        >
          Yes! Continue
        </v-btn>
      </template>
    </Dialog>
    <DeleteDialog :delete-dialog="deletejobDialog">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-18 font-weight-600 delete-text">
          Are you sure you want to delete this zone ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="deleteJobLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deletejobDialog = false"
          >No! Cancel</v-btn
        >
        <v-btn
          depressed
          :disabled="deleteJobLoading"
          :loading="deleteJobLoading"
          color="red lighten-1 white--text"
          v-on:click="deleteJobTypeConfirm()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteDialog>
  </v-container>
</template>

<script>
import { GET, PATCH, DELETE } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DeleteDialog from "@/view/pages/partials/Delete";

export default {
  name: "profile-job-setting",
  mixins: [ValidationMixin],
  data() {
    return {
     
      deleteJobLoading: false,
      confirm_dialog: false,
      confirm_loading: false,
      addZoneDialog: false,
      zonePayload: {
        name: null,
        status: null,
        country: null,
      },
      countryList: [

      {
        text : 'Singapore',
        value : 'Singapore'
      },

      {
        text : 'Malaysia',
        value : 'Malaysia'
      },

      ],
     
      statusList :[

      {
        text : 'Active',
        value : 1
      },

      { 

        text : 'Inactive',
        value : 0

      },


      ],
      locationPageLoading: false,
      is_exist: 0,

      zone_type_id: 0,
      deletejobDialog: false,
      allow_zones: false,
      pageLoading: true,
      dataLoading: false,
      setting: {
        prefix: null,
        client_remark: null,
        next_number: null,
        number_length: null,
        buffer_time: null,
        terms_conditions: null,
        admin_note: null,
        client_note: null,
        job_type: [],
      },
      allow_service_form: false,
      allow_voice_note: false,
      allow_is_image_editor: false,
      allow_stamp_note: false,
      app_setting: [],
      break_types: [],
      zoneList: [],
      summaryCerts: {
        active: 0,
        inactive: 0,
      },
    };
  },
  components: {
    Dialog,
    DeleteDialog,
  },
  methods: {
    toggleStatus(zone) {
      zone.status = zone.is_active ? 1 : 0;
      this.zonePayload = zone;
      this.updateZoneStatus();

    },  


    updateZoneStatus() {
      this.$store
        .dispatch(PATCH, {
          url: "setting/zones",
          data: this.zonePayload,
        })
    .then(() => {
      this.getServiceSetting();
    })
    .catch((error) => {
      this.logError(error);
    });

    },

    updatezonesType(param) {
      console.log(param);
      const _this = this;
      _this.is_exist = param.is_exist ? 1 : 0;
      _this.addZoneDialog = true;

      setTimeout(function () {
        _this.zonePayload = {
          id: _this.lodash.toSafeInteger(param.id),
          name: param?.name ? param.name : null,
          country: param.country ? param.country : null,
          status: param.is_active ? param.is_active : null,
        };
      }, 500);
    
    },

    getServiceSetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/zones" })
        .then(({ data }) => {
          if (Array.isArray(data.zones)) {
            _this.zoneList = data?.zones;
          }
          _this.allow_zones = data?.show_zones;
          if (Array.isArray(data.teams)) {
            _this.teams = data?.teams;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    deleteZones(data) {
      this.zone_type_id = data.id;
      this.is_exist = data.is_exist ? 1 : 0;
      this.deletejobDialog = true;
    },
    deleteJobTypeConfirm() {
      const _this = this;
      _this.deleteJobLoading = true;
      _this.$store
        .dispatch(DELETE, {
          url: `setting/zone`,
          data: {
            id: this.zone_type_id,
            is_exist: this.is_exist,
          },
        })
        .then(() => {
          _this.deleteJobLoading = false;
          _this.deletejobDialog = false;
          _this.getServiceSetting();
        })
        .catch((error) => {
          _this.logError(error);
          _this.deleteJobLoading = false;
        });
    },

    updateJobSettingData(type) {
      if (type == 0) {
        this.updateJobSettingZone();
      } else {
        this.confirm_dialog = true;
      }
    },
    updateJobSettingZone() {
      const _this = this;
      const formErrors = _this.validateForm(
        _this.$refs.ticketCollecttionFormSkills
      );

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          _this.pageLoading = false;
        }
        return false;
      }

      if (this.zonePayload?.color?.hexa) {
        let colorCode = this.zonePayload?.color?.hexa
          ? this.zonePayload?.color?.hexa
          : null;
        this.zonePayload.color = colorCode;
      }
      _this.pageLoading = true;
      _this.dataLoading = true;

      _this.$store
        .dispatch(PATCH, {
          url: "setting/zones",
          data: _this.zonePayload,

        })
        .then(() => {
          _this.getServiceSetting();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
          _this.pageLoading = false;
          _this.addZoneDialog = false;
        });
    },

    zoneDialogOpen() {
      this.zonePayload = {
        name: null,
        country: null,
        status: null,
      };
      this.addZoneDialog = true;
    },

    deleteJobType(index) {
      if (this.zoneList.length > 1) {
        this.zoneList.splice(index, 1);
      }
    },
    getJobSetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/job" })
        .then(({ data }) => {
          _this.setting = data;
          _this.app_setting = data.app_setting;
          _this.break_types = data.breaks;
          _this.allow_zones = data.allow_zones;
          if (data.job_type) {
            _this.zoneList = data.job_type.map((row) => {
              return { text: row };
            });
          }
          this.allow_service_form =
            data.allow_service_form && data.allow_service_form == 1
              ? true
              : false;
          this.allow_stamp_note =
            data.allow_stamp_note && data.allow_stamp_note == 1 ? true : false;
          this.allow_voice_note =
            data.allow_voice_note && data.allow_voice_note == 1 ? true : false;
          this.allow_is_image_editor =
            data.allow_is_image_editor && data.allow_is_image_editor == 1
              ? true
              : false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    this.getServiceSetting();
  },
};
</script>
<style scoped>
.v-card {
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
</style>
